var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:bolt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0549 9.375L19.8147 0.78125H7.09082L3.13574 14.8438H9.04497L7.1148 24.2188H9.98838L23.0858 9.375H16.0549ZM9.2832 22.6562H9.03179L10.9619 13.2812H5.19834L8.27451 2.34375H17.4256L13.6659 10.9375H19.6233L9.2832 22.6562Z",
    fill: "#800080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltPurple);
export default __webpack_public_path__ + "static/media/bolt_purple.34dd7d273f66676071561baffc8e8ecb.svg";
export { ForwardRef as ReactComponent };